/* Studio Kit · theme.js
   Everything is driven by data attributes, so sections need no JavaScript of their own:
   data-open-drawer / data-close-drawer, data-product-form, data-product, data-carousel,
   data-tabs, data-countdown, data-before-after, data-hotspot, data-recommendations,
   data-recently-viewed, data-motion, data-sticky-header, data-predictive-search, data-zoom. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const configEl = document.getElementById('ThemeConfig');
  const config = configEl ? JSON.parse(configEl.textContent) : { routes: {}, strings: {} };
  const routes = config.routes || {};
  const strings = config.strings || {};
  const root = (routes.root || '/').replace(/\/?$/, '/');
  const on = (event, selector, handler, opts) => document.addEventListener(event, (e) => {
    const el = e.target.closest && e.target.closest(selector);
    if (el) handler(e, el);
  }, opts);

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = config.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return two.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return two;
    });
  }
  window.ThemeMoney = money;

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = typeof id === 'string' ? document.getElementById(id) : id;
    if (!d) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    const panel = $('.drawer__panel', d);
    setTimeout(() => (($('[data-autofocus]', d) || panel) || d).focus({ preventScroll: true }), 60);
    d.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  }
  function closeDrawers(silent) {
    $$('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.classList.remove('no-scroll');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.ThemeDrawer = { open: openDrawer, close: closeDrawers };
  on('click', '[data-open-drawer]', (e, el) => {
    if (el.dataset.openDrawer === 'CartDrawer' && config.cartType !== 'drawer') return;
    const target = document.getElementById(el.dataset.openDrawer);
    if (!target) return;
    e.preventDefault();
    openDrawer(target);
  });
  on('click', '[data-close-drawer]', (e) => { e.preventDefault(); closeDrawers(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawers(); closeLightbox(); }
  });

  /* ---------- cart (Shopify AJAX API + Section Rendering) ---------- */
  const cart = {
    sections: () => ['cart-drawer', ...$$('[data-cart-section]').map((el) => el.dataset.cartSection)].filter((v, i, a) => a.indexOf(v) === i),
    render(sections) {
      if (!sections) return;
      for (const [id, html] of Object.entries(sections)) {
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-cart-fragment]', doc).forEach((fresh) => {
          const key = fresh.dataset.cartFragment;
          $$(`[data-cart-fragment="${key}"]`).forEach((current) => current.replaceWith(fresh.cloneNode(true)));
        });
        void id;
      }
      const countEl = $('[data-cart-fragment] [data-cart-count-value]');
      const count = countEl ? Number(countEl.dataset.cartCountValue) : null;
      if (count !== null) $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
      initRecommendations(document);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },
    async refresh() {
      const res = await fetch(`${root}?sections=${this.sections().join(',')}`);
      this.render(await res.json());
    },
    async add(body) {
      const isForm = body instanceof FormData;
      if (isForm) { body.append('sections', this.sections().join(',')); body.append('sections_url', location.pathname); }
      else Object.assign(body, { sections: this.sections().join(','), sections_url: location.pathname });
      const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: isForm ? body : JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      this.render(data.sections);
      if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
      else if (config.cartType !== 'drawer') location.href = routes.cart || '/cart';
      return data;
    },
    async change(line, quantity) {
      const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: this.sections().join(','), sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not update cart');
      this.render(data.sections);
    },
    async note(text) {
      await fetch(`${routes.cartUpdate || '/cart/update'}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: text }) });
    },
  };
  window.ThemeCart = cart;

  function formError(form, message) {
    let box = $('[data-form-error]', form);
    if (!box) { box = document.createElement('p'); box.className = 'form-status form-status--error'; box.dataset.formError = ''; form.appendChild(box); }
    box.textContent = message;
    box.hidden = !message;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (config.cartType === 'page' && !form.hasAttribute('data-ajax-always')) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (btn) btn.setAttribute('aria-busy', 'true');
    formError(form, '');
    try {
      const fd = new FormData(form);
      const extra = $$('[data-addon-input]:checked', form.closest('[data-product]') || form).map((el) => el.value).filter(Boolean);
      if (extra.length) {
        const main = { id: fd.get('id'), quantity: Number(fd.get('quantity') || 1) };
        const props = {};
        for (const [k, v] of fd.entries()) { const m = /^properties\[(.+)\]$/.exec(k); if (m && String(v).trim()) props[m[1]] = v; }
        if (Object.keys(props).length) main.properties = props;
        if (fd.get('selling_plan')) main.selling_plan = fd.get('selling_plan');
        const items = [main].concat(extra.map((id) => ({ id, quantity: 1 })));
        await cart.add({ items });
      } else await cart.add(fd);
    } catch (err) {
      formError(form, err.message);
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  });

  on('click', '[data-cart-qty]', async (e, el) => {
    e.preventDefault();
    el.setAttribute('aria-busy', 'true');
    try { await cart.change(Number(el.dataset.line), Number(el.dataset.cartQty)); } catch (err) { alert(err.message); }
  });
  on('change', '[data-cart-qty-input]', async (e, el) => {
    try { await cart.change(Number(el.dataset.line), Math.max(0, Number(el.value) || 0)); } catch (err) { alert(err.message); }
  });
  on('change', '[data-cart-note]', (e, el) => cart.note(el.value));
  on('click', '[data-quick-add]', async (e, el) => {
    e.preventDefault();
    el.setAttribute('aria-busy', 'true');
    try { await cart.add({ items: [{ id: Number(el.dataset.quickAdd), quantity: 1 }] }); } catch (err) { alert(err.message); }
    el.removeAttribute('aria-busy');
  });

  /* ---------- quantity steppers ---------- */
  on('click', '[data-qty-step]', (e, el) => {
    const input = $('input', el.closest('.qty'));
    if (!input) return;
    const min = Number(input.min || 1);
    input.value = Math.max(min, (Number(input.value) || min) + Number(el.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product: variants, media, sticky bar, quantity breaks ---------- */
  function initProduct(rootEl) {
    if (rootEl.dataset.productReady) return;
    rootEl.dataset.productReady = '1';
    const dataEl = $('[data-product-json]', rootEl);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const inventory = (() => { try { return JSON.parse($('[data-inventory-json]', rootEl)?.textContent || '{}'); } catch { return {}; } })();
    const preorder = (() => { try { return JSON.parse($('[data-preorder-json]', rootEl)?.textContent || '{}'); } catch { return {}; } })();
    const idInputs = $$('input[name="id"]', rootEl);
    const optionInputs = () => $$('[data-option-index]', rootEl);
    const selected = () => {
      const opts = [];
      for (const el of optionInputs()) {
        const i = Number(el.dataset.optionIndex);
        if (el.tagName === 'SELECT') opts[i] = el.value;
        else if (el.checked) opts[i] = el.value;
      }
      return opts;
    };
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

    function update(variant) {
      const btns = $$('[data-add-button]', rootEl).concat($$(`[data-sticky-for="${rootEl.id}"] [data-add-button]`));
      if (!variant) {
        btns.forEach((b) => { b.disabled = true; $('[data-add-label]', b) && ($('[data-add-label]', b).textContent = strings.unavailable || 'Unavailable'); });
        return;
      }
      idInputs.forEach((i) => { i.value = variant.id; });
      const price = variant.price;
      const compare = variant.compare_at_price;
      $$('[data-price]', rootEl).concat($$(`[data-sticky-for="${rootEl.id}"] [data-price]`)).forEach((el) => {
        el.classList.toggle('price--sale', compare > price);
        const cur = $('.price__current', el); if (cur) cur.textContent = money(price);
        const cmp = $('.price__compare', el); if (cmp) { cmp.textContent = compare > price ? money(compare) : ''; cmp.hidden = !(compare > price); }
        const save = $('.price__save', el);
        if (save) {
          save.hidden = !(compare > price);
          if (compare > price) save.textContent = (save.dataset.mode === 'amount') ? `${strings.save || 'Save'} ${money(compare - price)}` : `-${Math.round(((compare - price) * 100) / compare)}%`;
        }
      });
      const preBlock = $('[data-preorder-block]', rootEl);
      const isPre = !!(preBlock && preorder[variant.id] && variant.available);
      btns.forEach((b) => {
        b.disabled = !variant.available;
        const label = $('[data-add-label]', b);
        if (label) label.textContent = variant.available ? (isPre ? preBlock.dataset.label : (b.dataset.label || strings.addToCart || 'Add to cart')) : (strings.soldOut || 'Sold out');
      });
      if (preBlock) {
        const note = $('[data-preorder-note]', preBlock); if (note) note.hidden = !isPre;
        const notify = $('[data-notify]', preBlock); if (notify) notify.hidden = variant.available;
        const body = $('[data-notify-body]', preBlock); if (body) body.value = `Back-in-stock request: ${variant.name || product.handle} (variant ${variant.id})`;
      }
      $$('[data-add-price]', rootEl).forEach((el) => { el.textContent = ` · ${money(price)}`; el.hidden = !variant.available; });
      $$('[data-unit-price]', rootEl).forEach((el) => { const u = Number(el.dataset.units || 0); const v = $('[data-unit-value]', el); if (u > 0 && v) v.textContent = money(Math.round(price / u)); });
      $$('[data-price-note]', rootEl).forEach((el) => { el.hidden = !(compare > price); });
      $$('[data-option-value]', rootEl).forEach((el) => {
        const i = Number(el.dataset.optionIndex);
        const value = el.value;
        const test = selected().slice();
        test[i] = value;
        const match = product.variants.find((v) => v.options.every((o, j) => o === test[j]));
        el.closest('.option-value')?.classList.toggle('is-unavailable', !match || !match.available);
      });
      $$('[data-tier]', rootEl).forEach((t) => {
        const q = Number(t.dataset.qty || 1);
        const pct = Number(t.dataset.pct || 0);
        const total = price * q;
        const disc = Math.round((total * (100 - pct)) / 100);
        const a = $('[data-tier-total]', t); if (a) a.textContent = money(disc);
        const b = $('[data-tier-compare]', t); if (b) { b.textContent = pct > 0 ? money(total) : ''; b.hidden = !(pct > 0); }
      });
      $$('[data-selected-value]', rootEl).forEach((el) => { el.textContent = variant.options[Number(el.dataset.selectedValue)] || ''; });
      const stock = $('[data-stock]', rootEl);
      if (stock) {
        const qty = inventory[variant.id];
        const low = Number(stock.dataset.threshold || 5);
        stock.classList.remove('is-low', 'is-out', 'is-in');
        if (!variant.available) { stock.textContent = strings.soldOut || 'Sold out'; stock.classList.add('is-out'); }
        else if (typeof qty === 'number' && qty > 0 && qty <= low) { stock.textContent = (strings.lowStock || 'Only {{ count }} left').replace(/\{\{\s*count\s*\}\}/, qty); stock.classList.add('is-low'); }
        else { stock.textContent = strings.inStock || 'In stock'; stock.classList.add('is-in'); }
      }
      if (variant.featured_media && variant.featured_media.id) showMedia(rootEl, variant.featured_media.id);
      if (rootEl.dataset.updateUrl !== 'false' && history.replaceState) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      rootEl.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    }
    rootEl.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-index]')) update(findVariant(selected()));
      if (e.target.matches('[data-qty-break]')) {
        const q = $('input[name="quantity"]', rootEl);
        if (q) q.value = e.target.value;
      }
    });
    const initial = findVariant(selected());
    if (initial) update(initial);

    // Sticky add-to-cart bar
    const sticky = $(`[data-sticky-for="${rootEl.id}"]`);
    const buyBox = $('[data-buy-box]', rootEl);
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(buyBox);
      sticky.addEventListener('click', (e) => {
        if (!e.target.closest('[data-sticky-buy]')) return;
        e.preventDefault();
        const form = $('[data-product-form]', rootEl);
        if (form && form.requestSubmit) form.requestSubmit(); else buyBox.scrollIntoView({ behavior: 'smooth' });
      });
    }
    // Recently viewed
    try {
      const list = JSON.parse(localStorage.getItem('recently-viewed') || '[]').filter((h) => h !== product.handle);
      list.unshift(product.handle);
      localStorage.setItem('recently-viewed', JSON.stringify(list.slice(0, 12)));
    } catch {}
  }

  /* ---------- delivery date (merchant's own business-day range, worked out in the shopper's browser) ---------- */
  function initEta(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const min = Number(el.dataset.min || 0);
    const max = Math.max(min, Number(el.dataset.max || 0));
    const cutoff = Number(el.dataset.cutoff || 0);
    const off = el.dataset.off || 'weekends';
    const holidays = new Set((el.dataset.holidays || '').split(/[\s,]+/).filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)));
    const tz = /^([+-])(\d{2})(\d{2})$/.exec(el.dataset.tz || '');
    const offsetMin = tz ? (tz[1] === '-' ? -1 : 1) * (Number(tz[2]) * 60 + Number(tz[3])) : -new Date().getTimezoneOffset();
    const storeNow = () => new Date(Date.now() + offsetMin * 60000); // UTC fields = store wall clock
    const key = (d) => d.toISOString().slice(0, 10);
    const working = (d) => { const w = d.getUTCDay(); if (off === 'weekends' && (w === 0 || w === 6)) return false; if (off === 'sunday' && w === 0) return false; return !holidays.has(key(d)); };
    const addWorking = (d, n) => { const x = new Date(d); let left = n; while (left > 0) { x.setUTCDate(x.getUTCDate() + 1); if (working(x)) left -= 1; } return x; };
    const fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    const render = () => {
      const now = storeNow();
      let ship = new Date(now);
      const today = working(now) && now.getUTCHours() < cutoff;
      if (!today) { do { ship.setUTCDate(ship.getUTCDate() + 1); } while (!working(ship)); }
      const a = addWorking(ship, min);
      const b = addWorking(ship, max);
      const dates = $('[data-eta-dates]', el);
      if (dates) dates.textContent = key(a) === key(b) ? fmt.format(a) : `${fmt.format(a)} – ${fmt.format(b)}`;
      const cut = $('[data-eta-cutoff]', el);
      if (cut) {
        const show = el.dataset.countdownOn === 'true' && today;
        cut.hidden = !show;
        if (show) {
          const end = new Date(now); end.setUTCHours(cutoff, 0, 0, 0);
          const mins = Math.max(1, Math.round((end - now) / 60000));
          $('[data-eta-left]', el).textContent = mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${mins}m`;
        }
      }
    };
    render();
    setInterval(render, 60000);
  }

  /* ---------- gift message ---------- */
  on('change', '[data-gift-toggle]', (e, el) => {
    const box = el.closest('[data-gift]');
    const fields = $('[data-gift-fields]', box);
    if (!fields) return;
    fields.hidden = !el.checked;
    $$('input, textarea', fields).forEach((i) => { i.disabled = !el.checked; if (!el.checked && i.type === 'checkbox') i.checked = false; });
    if (el.checked) $('[data-gift-message]', fields)?.focus();
  });
  on('input', '[data-gift-message]', (e, el) => {
    const c = $('[data-gift-count]', el.closest('[data-gift]'));
    if (c) c.textContent = `${el.value.length} / ${el.maxLength}`;
  });

  /* ---------- stock bar (main-product block stock_bar): real inventory of the selected variant ---------- */
  function init_stock_bar(scope) {
    $$('[data-stock-bar]', scope).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      if (el.hasAttribute('data-sample')) return; // editor sample for untracked products stays as rendered
      const rootEl = el.closest('[data-product]');
      if (!rootEl) return;
      let inv = {};
      try { inv = JSON.parse($('[data-inventory-json]', rootEl)?.textContent || '{}'); } catch {}
      const threshold = Number(el.dataset.threshold || 10);
      const max = Math.max(threshold, Number(el.dataset.max || 30));
      const design = el.hasAttribute('data-design');
      const body = $('[data-stock-bar-body]', el);
      const textEl = $('[data-stock-bar-text]', el);
      const fill = $('.mp-stock-bar__fill', el);
      const hint = $('[data-stock-bar-hint]', el);
      const render = (variant) => {
        const qty = variant ? inv[variant.id] : null;
        let state = 'hidden';
        if (variant && variant.available && typeof qty === 'number' && qty > 0) {
          if (qty <= threshold) state = 'low';
          else if (el.dataset.textOk) state = 'ok';
        }
        el.classList.remove('is-low', 'is-ok', 'is-hidden');
        el.classList.add(`is-${state}`);
        if (body) body.hidden = state === 'hidden';
        if (hint) hint.hidden = state !== 'hidden';
        el.hidden = state === 'hidden' && !design;
        if (state === 'hidden' || !textEl) return;
        const tpl = (state === 'low' ? el.dataset.textLow : el.dataset.textOk) || '';
        const nodes = [];
        tpl.split('[count]').forEach((part, i) => {
          if (i) { const s = document.createElement('strong'); s.textContent = qty; nodes.push(s); }
          if (part) nodes.push(document.createTextNode(part));
        });
        textEl.replaceChildren(...nodes);
        if (fill) fill.style.setProperty('--fill', `${Math.max(4, Math.min(100, Math.round((qty * 100) / max)))}%`);
      };
      rootEl.addEventListener('variant:change', (e) => render(e.detail && e.detail.variant));
    });
  }

  /* ---------- sale banner (main-product block sale_banner): countdown via initCountdown, per-variant visibility ---------- */
  function init_sale_banner(scope) {
    $$('[data-sale-banner]', scope).forEach((el) => {
      if (el.dataset.saleReady) return; // data-ready belongs to initCountdown
      el.dataset.saleReady = '1';
      if (el.dataset.onlySale !== 'true') return;
      const rootEl = el.closest('[data-product]');
      if (!rootEl) return;
      const inner = $('[data-sale-banner-inner]', el);
      const hint = $('[data-sale-banner-hint]', el);
      const design = !!hint;
      rootEl.addEventListener('variant:change', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;
        const end = Date.parse(el.dataset.countdown);
        if (!end || end <= Date.now()) { el.hidden = true; return; } // ended: initCountdown hides it, never bring it back
        const onSale = Number(v.compare_at_price) > Number(v.price);
        if (inner) inner.hidden = !onSale;
        if (hint) hint.hidden = onSale;
        el.hidden = !onSale && !design;
      });
    });
  }

  /* ---------- bundle cards (main-product block bundle_cards): per-unit price, initial quantity, stepper sync ----------
     The theme already copies a checked [data-qty-break] into input[name=quantity] and refreshes
     [data-tier-total] / [data-tier-compare] on variant change. */
  function init_bundle_cards(scope) {
    $$('[data-bundle-cards]', scope).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const rootEl = el.closest('[data-product]');
      if (!rootEl) return;
      const qtyInput = () => $('input[name="quantity"]', rootEl);
      const checked = $('[data-qty-break]:checked', el);
      if (checked && qtyInput()) qtyInput().value = checked.value;
      rootEl.addEventListener('variant:change', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;
        $$('[data-tier]', el).forEach((t) => {
          const q = Math.max(1, Number(t.dataset.qty || 1));
          const pct = Number(t.dataset.pct || 0);
          const disc = Math.round((v.price * q * (100 - pct)) / 100);
          const u = $('[data-tier-unit]', t);
          if (u) u.textContent = money(Math.round(disc / q));
        });
      });
      // Quantity typed or stepped in the buy form → select the matching card (or none).
      rootEl.addEventListener('change', (e) => {
        const q = qtyInput();
        if (!q || e.target !== q) return;
        $$('[data-qty-break]', el).forEach((r) => { r.checked = r.value === String(Number(q.value)); });
      });
    });
  }

  /* ---------- free-shipping progress (main-product block shipping_progress): real cart total vs merchant threshold ---------- */
  function init_shipping_progress(scope) {
    $$('[data-shipping-progress]', scope).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
      const threshold = Math.round(Number(el.dataset.threshold || 0) * rate); // shop currency → shopper's currency
      if (!threshold) return;
      const textEl = $('[data-shipping-text]', el);
      const fill = $('.mp-shipping-progress__fill', el);
      const tokens = (tpl, map) => {
        const nodes = [];
        tpl.split(/(\[amount\]|\[threshold\])/).forEach((part) => {
          if (map[part] !== undefined) { const s = document.createElement('strong'); s.textContent = map[part]; nodes.push(s); }
          else if (part) nodes.push(document.createTextNode(part));
        });
        return nodes;
      };
      const render = (total) => {
        const left = threshold - total;
        const done = left <= 0;
        const pct = done ? 100 : Math.max(0, Math.min(100, Math.floor((total * 100) / threshold)));
        el.classList.toggle('is-done', done);
        if (textEl) textEl.replaceChildren(...tokens(done ? (el.dataset.textDone || '') : (el.dataset.textAway || ''), { '[amount]': money(Math.max(0, left)), '[threshold]': money(threshold) }));
        if (fill) fill.style.setProperty('--fill', `${pct}%`);
      };
      if (rate !== 1) render(Number(el.dataset.total || 0));
      const shopRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root || '/').replace(/\/?$/, '/');
      document.addEventListener('cart:updated', async () => {
        if (!el.isConnected) return;
        try {
          const res = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          const c = await res.json();
          render(Number(c.total_price) || 0);
        } catch {}
      });
    });
  }

  /* ---------- instalments (main-product block installments): keep Shopify's payment terms on the selected variant ---------- */
  function init_installments(scope) {
    $$('[data-installments]', scope).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const rootEl = el.closest('[data-product]');
      const idInput = $('[data-installments-id]', el);
      // theme.js already updates every input[name="id"] in the product; fire "change" so <shopify-payment-terms> re-reads it.
      if (rootEl && idInput) {
        rootEl.addEventListener('variant:change', (e) => {
          const v = e.detail && e.detail.variant;
          if (!v) return;
          idInput.value = v.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      // Card chrome only once Shopify has rendered a message (it stays empty when Shop Pay Installments is off).
      const terms = $('shopify-payment-terms', el);
      if (terms && 'ResizeObserver' in window) {
        new ResizeObserver(() => el.classList.toggle('has-terms', terms.offsetHeight > 4)).observe(terms);
      }
    });
  }

  /* ---------- gallery ---------- */
  function showMedia(scope, mediaId) {
    const gallery = $('[data-gallery]', scope);
    if (!gallery) return;
    const slide = $(`[data-media-id="${mediaId}"]`, gallery);
    if (!slide) return;
    const track = $('[data-gallery-track]', gallery);
    if (track && track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    else if (gallery.dataset.layout === 'stacked' || gallery.dataset.layout === 'grid') { /* all visible */ }
    $$('[data-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(mediaId))));
  }
  on('click', '[data-thumb]', (e, el) => {
    e.preventDefault();
    showMedia(el.closest('[data-product], [data-gallery-scope]') || document, el.dataset.thumb);
  });
  function initGallery(gallery) {
    const track = $('[data-gallery-track]', gallery);
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const slides = $$('[data-media-id]', track);
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting && en.intersectionRatio > .6) {
          $$('[data-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === en.target.dataset.mediaId)));
          const dots = $$('[data-gallery-dot]', gallery);
          dots.forEach((d, i) => d.classList.toggle('is-active', slides[i] === en.target));
        }
      });
    }, { root: track, threshold: [.6] });
    slides.forEach((s) => io.observe(s));
  }

  /* ---------- lightbox (data-zoom on images) ---------- */
  function closeLightbox() { const lb = $('[data-lightbox]'); if (lb) lb.hidden = true; }
  on('click', '[data-zoom]', (e, el) => {
    const lb = $('[data-lightbox]');
    if (!lb) return;
    e.preventDefault();
    const img = $('img', lb);
    img.src = el.dataset.zoom;
    img.alt = el.getAttribute('aria-label') || '';
    lb.hidden = false;
    $('[data-lightbox-close]', lb)?.focus();
  });
  on('click', '[data-lightbox-close], [data-lightbox]', (e, el) => { if (e.target === el || el.matches('[data-lightbox-close]')) closeLightbox(); });

  /* ---------- carousels ---------- */
  function initCarousel(c) {
    if (c.dataset.ready) return;
    c.dataset.ready = '1';
    const track = $('[data-carousel-track]', c) || $('.carousel__track', c);
    if (!track) return;
    const step = () => { const first = track.children[0]; return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    $$('[data-carousel-prev]', c).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
    $$('[data-carousel-next]', c).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
    const dotsBox = $('[data-carousel-dots]', c);
    const slides = [...track.children];
    if (dotsBox && slides.length > 1) {
      dotsBox.innerHTML = slides.map((_, i) => `<button type="button" class="carousel__dot" aria-label="Slide ${i + 1}"></button>`).join('');
      $$('.carousel__dot', dotsBox).forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' })));
    }
    const sync = () => {
      const x = track.scrollLeft;
      let idx = 0;
      slides.forEach((s, i) => { if (s.offsetLeft - track.offsetLeft <= x + 10) idx = i; });
      $$('.carousel__dot', c).forEach((d, i) => d.classList.toggle('is-active', i === idx));
      slides.forEach((sl, i) => sl.classList.toggle('is-active', i === idx));
      $$('[data-carousel-prev]', c).forEach((b) => { b.disabled = x <= 2; });
      $$('[data-carousel-next]', c).forEach((b) => { b.disabled = x + track.clientWidth >= track.scrollWidth - 2; });
      c.dataset.index = idx;
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
    const auto = Number(c.dataset.autoplay || 0);
    if (auto > 0 && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer = null;
      const start = () => {
        stop();
        timer = setInterval(() => {
          if (document.hidden) return;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
        }, auto * 1000);
      };
      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      let paused = false;
      c.addEventListener('mouseenter', stop);
      c.addEventListener('mouseleave', () => { if (!paused) start(); });
      c.addEventListener('focusin', stop);
      c.addEventListener('focusout', () => { if (!paused) start(); });
      $$('[data-carousel-pause]', c).forEach((b) => b.addEventListener('click', () => {
        paused = !paused;
        b.setAttribute('aria-pressed', String(paused));
        if (paused) stop(); else start();
      }));
      c.carousel = { pause: () => { paused = true; stop(); }, play: () => { paused = false; start(); } };
      start();
    }
  }

  /* ---------- tabs ---------- */
  on('click', '[data-tab]', (e, tab) => {
    const box = tab.closest('[data-tabs]');
    if (!box) return;
    e.preventDefault();
    $$('[data-tab]', box).forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    $$('[data-tab-panel]', box).forEach((p) => { p.hidden = p.dataset.tabPanel !== tab.dataset.tab; });
    box.querySelectorAll('[data-carousel]').forEach((c) => { delete c.dataset.ready; initCarousel(c); });
  });

  /* ---------- countdown (to a real, merchant-set end time) ---------- */
  function initCountdown(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const end = Date.parse(el.dataset.countdown);
    if (!end) { el.hidden = true; return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      const set = (k, v) => $$(`[data-cd="${k}"]`, el).forEach((x) => { x.textContent = pad(v); });
      set('d', d); set('h', h); set('m', m); set('s', s);
      if (left <= 0) {
        clearInterval(timer);
        if (el.dataset.expired === 'hide') (el.closest('[data-countdown-scope]') || el).hidden = true;
        else $$('[data-countdown-done]', el.closest('[data-countdown-scope]') || el).forEach((x) => { x.hidden = false; });
      }
    };
    const timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- before / after slider ---------- */
  on('input', '[data-before-after] input[type="range"]', (e, input) => {
    input.closest('[data-before-after]').style.setProperty('--pos', `${input.value}%`);
  });

  /* ---------- hotspots ---------- */
  on('click', '[data-hotspot]', (e, el) => {
    e.preventDefault();
    const box = el.closest('[data-hotspots]');
    const open = el.getAttribute('aria-expanded') === 'true';
    $$('[data-hotspot]', box).forEach((h) => h.setAttribute('aria-expanded', 'false'));
    el.setAttribute('aria-expanded', String(!open));
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-hotspot], .hotspot__card')) $$('[data-hotspot][aria-expanded="true"]').forEach((h) => h.setAttribute('aria-expanded', 'false'));
  });

  /* ---------- product recommendations (related / complementary), loaded via Section Rendering ---------- */
  async function loadRecommendations(el) {
    if (el.dataset.loaded) return;
    el.dataset.loaded = '1';
    const url = el.dataset.recommendations;
    if (!url) return;
    try {
      const res = await fetch(url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        el.hidden = false;
        $$('[data-carousel]', el).forEach(initCarousel);
        initMotion(el);
      } else if (el.dataset.hideEmpty !== 'false') (el.closest('[data-recommendations-scope]') || el).hidden = true;
    } catch {}
  }
  function initRecommendations(scope) {
    const els = $$('[data-recommendations]:not([data-loaded])', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(loadRecommendations); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); loadRecommendations(en.target); } }), { rootMargin: '400px 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- recently viewed ---------- */
  async function initRecentlyViewed(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('recently-viewed') || '[]'); } catch {}
    const current = el.dataset.exclude;
    handles = handles.filter((h) => h && h !== current).slice(0, Number(el.dataset.limit || 4));
    const scope = el.closest('[data-recently-viewed-scope]') || el;
    if (!handles.length) { scope.hidden = true; return; }
    const target = $('[data-recently-viewed-items]', el) || el;
    const tpl = $('template', el);
    const products = (await Promise.all(handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    if (!products.length) { scope.hidden = true; return; }
    target.innerHTML = products.map((p) => {
      const img = p.featured_image ? (String(p.featured_image).startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
      const html = tpl ? tpl.innerHTML : '<a class="mini-card" href="{url}">{img}<span class="mini-card__title">{title}</span><span class="price">{price}</span></a>';
      return html.replace(/\{url\}/g, p.url).replace(/\{title\}/g, p.title.replace(/</g, '&lt;')).replace(/\{price\}/g, money(p.price))
        .replace(/\{img\}/g, img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=600" alt="" loading="lazy">` : '');
    }).join('');
    scope.hidden = false;
  }

  /* ---------- predictive search ---------- */
  function initPredictive(form) {
    if (form.dataset.ready || config.predictiveSearch === false) return;
    form.dataset.ready = '1';
    const input = $('input[name="q"]', form);
    const results = $('[data-predictive-results]', form.closest('[data-predictive-scope]') || form);
    if (!input || !results) return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${routes.predictiveSearch || root + 'search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('[data-predictive-content]', doc);
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch {}
      }, 220);
    });
  }

  /* ---------- header ---------- */
  function initHeader() {
    const header = $('[data-sticky-header]');
    if (!header) return;
    const mode = header.dataset.stickyHeader;
    let lastY = scrollY;
    const onScroll = () => {
      const y = scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (mode === 'smart') header.classList.toggle('is-hidden', y > lastY && y > 300);
      lastY = y;
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    const setH = () => document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
    setH();
    addEventListener('resize', setH);
  }
  on('mouseenter', '[data-mega-trigger]', (e, el) => { el.setAttribute('aria-expanded', 'true'); }, true);
  on('mouseleave', '[data-mega-trigger]', (e, el) => { el.setAttribute('aria-expanded', 'false'); }, true);

  /* ---------- announcement rotator ---------- */
  function initRotator(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const items = $$('[data-rotator-item]', el);
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => { i = (n + items.length) % items.length; items.forEach((it, j) => { it.hidden = j !== i; }); };
    $$('[data-rotator-prev]', el).forEach((b) => b.addEventListener('click', () => show(i - 1)));
    $$('[data-rotator-next]', el).forEach((b) => b.addEventListener('click', () => show(i + 1)));
    const speed = Number(el.dataset.rotator || 5);
    if (speed > 0) setInterval(() => { if (!el.matches(':hover')) show(i + 1); }, speed * 1000);
    show(0);
  }

  /* ---------- scroll motion ---------- */
  function initMotion(scope) {
    if (document.body.classList.contains('motion--none') || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('motion-ready');
    const els = $$('[data-motion]:not(.is-in)', scope);
    els.forEach((el) => {
      const items = $$('[data-motion-item]', el);
      if (items.length) { el.classList.add('has-items'); items.forEach((it, i) => it.style.setProperty('--i', String(i % 8))); }
    });
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((el) => io.observe(el));
    setTimeout(() => els.forEach((el) => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }), 1200);
  }

  /* ---------- size guide, share, misc ---------- */
  on('click', '[data-share]', async (e, el) => {
    e.preventDefault();
    const url = el.dataset.share || location.href;
    try { if (navigator.share) await navigator.share({ url, title: document.title }); else { await navigator.clipboard.writeText(url); el.dataset.copied = 'true'; setTimeout(() => delete el.dataset.copied, 1600); } } catch {}
  });
  on('change', '[data-purchase-option]', (e, el) => {
    const scope = el.closest('[data-product]') || document;
    const input = $('[data-selling-plan-input]', scope);
    if (!input) return;
    input.value = el.value;
    input.disabled = !el.value;
  });
  on('click', '[data-copy]', async (e, el) => {
    e.preventDefault();
    try { await navigator.clipboard.writeText(el.dataset.copy); } catch {}
    const label = el.dataset.copiedLabel;
    if (label) { const old = el.innerHTML; el.textContent = label; setTimeout(() => { el.innerHTML = old; }, 1600); }
    el.dataset.copied = 'true';
    setTimeout(() => delete el.dataset.copied, 1600);
  });
  on('change', '[data-auto-submit]', (e, el) => { (el.form || el.closest('form'))?.requestSubmit(); });

  /* ---------- init ---------- */
  function init(scope = document) {
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-carousel]', scope).forEach(initCarousel);
    $$('[data-countdown]', scope).forEach(initCountdown);
    $$('[data-eta]', scope).forEach(initEta);
    $$('[data-rotator]', scope).forEach(initRotator);
    $$('[data-recently-viewed]', scope).forEach(initRecentlyViewed);
    $$('[data-predictive-search]', scope).forEach(initPredictive);
    init_stock_bar(scope);
    init_sale_banner(scope);
    init_bundle_cards(scope);
    init_shipping_progress(scope);
    init_installments(scope);
    initRecommendations(scope);
    initMotion(scope);
  }
  const boot = () => { initHeader(); init(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  window.ThemeInit = init;
})();
